import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Row, Col,
  Card, CardBody, Table
} from 'reactstrap';
class NewFleetBusinessRelatedDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: [],
      fleetByIdData: {}
    }
    this.createDynamicControl('JK Tyre');
    this.createDynamicControl('Birla');
    this.createDynamicControl('Apollo');
    this.createDynamicControl('MRF');
    this.createDynamicControl('CEAT');
    this.createDynamicControl('Birdgestone');
    this.createDynamicControl('Michellin');
    this.createDynamicControl('Chinese Type');
    this.createDynamicControl('Others');
  }

  createDynamicControl = (type) => {
    let { controls } = this.state;
    controls.push({
      radial: '',
      bias: '',
      reason: '',
      type: type
    })
  }

  handleInputChange = (e, index, type) => {
    let { controls } = this.state;
    if (type !== 'reason') {
      if (!isNaN(e.target.value)) {
        controls[index][type] = +e.target.value;
      }
    } else {
      controls[index][type] = e.target.value;
    }
    this.setState((prevState) => {
      return { ...prevState, controls };
    });
  }

  setFleetDetail = () => {
    let { fleetByIdData, controls } = this.state;
    fleetByIdData = this.props.fleetByIdData
    if (fleetByIdData && Object.keys(fleetByIdData).length > 0) {
      if (fleetByIdData.business_related_detail && fleetByIdData.business_related_detail.length > 0) {
        fleetByIdData.business_related_detail.forEach(element => {
          if (element.bias || element.radial || element.reason) {
            let index = controls.findIndex((o) => o.type === element.type);
            if (index > -1) {
              controls[index].bias = element.bias;
              controls[index].radial = element.radial;
              controls[index].reason = element.reason;
            }
          }
        });
      }
      this.setState((prevState) => {
        return { ...prevState, controls };
      });
    }
  }

  render() {
    const { controls } = this.state;
    return (
      <>
        <Card style={{ marginTop: '5px' }}>
          <CardBody>
            <Row>
              <Col xl="12" md="12" xs="12">
                <b className="margin-right-16">BUSINESS RELATED DETAIILS</b>
              </Col>
              <span className="note-rect" style={{ border: 'none', marginLeft: '15px', marginTop: '3px', padding: '0' }}>Other Truck Bus Radial/ Bias Tyres bought Last year</span>
            </Row>
            <hr />
            {/* <span className="note-rect">Other Truck Bus Radial/ Bias Tyres bought Last year</span> */}
            <Table className="mb-0 table-responsive mt-3" bordered>
              <thead>
                <tr style={{ backgroundColor: '#f6f6f6' }}>
                  <th style={{ border: '1px solid #e9ecef' }}>Brands</th>
                  <th style={{ border: '1px solid #e9ecef' }}>Radial (Qty.)</th>
                  <th style={{ border: '1px solid #e9ecef' }}>Bias (Qty.)</th>
                  <th style={{ border: '1px solid #e9ecef' }}>Reason</th>
                </tr>
              </thead>
              <tbody>
                {
                  controls.map((item, i) => (
                    <tr>
                      <td>
                        <span className="brand-lbl">{item.type}</span>
                      </td>
                      <td>
                        <Col style={{ paddingLeft: '0' }}>
                          <FormGroup>
                            <Input
                              type="text"
                              autocomplete="nofill"
                              name='radial'
                              value={item.radial}
                              onChange={(e) => { this.handleInputChange(e, i, 'radial') }}
                              placeholder="Type here" />
                          </FormGroup>
                        </Col>
                      </td>
                      <td>
                        <Col style={{ paddingLeft: '0' }}>
                          <FormGroup>
                            <Input
                              type="text"
                              autocomplete="nofill"
                              name='bias'
                              value={item.bias}
                              onChange={(e) => { this.handleInputChange(e, i, 'bias') }}
                              placeholder="Type here" />
                          </FormGroup>
                        </Col>
                      </td>
                      <td>
                        <Col style={{ paddingLeft: '0' }}>
                          <FormGroup>
                            <Input
                              type="text"
                              autocomplete="nofill"
                              name='reason'
                              value={item.reason}
                              onChange={(e) => { this.handleInputChange(e, i, 'reason') }}
                              placeholder="Type here" />
                          </FormGroup>
                        </Col>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default NewFleetBusinessRelatedDetails;